﻿<template>
  <Transition
    :appear="false"
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="opacity-0 -translate-y-2"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition duration-300 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 -translate-y-3"
  >
    <section
      v-if="visible"
      class="relative overflow-hidden rounded-b-xl shadow-md will-change-transform
             bg-gradient-to-r from-[#dd4e94] via-[#f17eb5] to-[#dd4e94]"
      aria-label="Welcome banner"
    >
      <!-- Close button -->
      <button
        @click="closeBanner"
        class="absolute top-2 right-2 h-10 w-10 grid place-items-center rounded-full text-white/95
               hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/90
               focus-visible:ring-offset-2 focus-visible:ring-offset-pink-500 transition"
        aria-label="Close banner"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
      </button>

      <div :class="containerClasses">
        <p :class="textClasses" class="text-white">
          Welcome to our new Agent Portal! We’re excited to have you here.
          If you experience any issues, please contact us at
          <a href="mailto:agents@radicaltravel.com" class="text-[#ffe6f2] underline underline-offset-2 hover:text-white">
            agents@radicaltravel.com
          </a>
          or call
          <a href="tel:+441315583738" class="text-[#ffe6f2] underline underline-offset-2 hover:text-white">
            +44 131 558 3738
          </a>.
        </p>
      </div>
    </section>
  </Transition>
</template>

<script lang="ts" src="./banner.ts"></script>
